import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

function Analytics() {
  const location = useLocation();

  const getUserEmail = useCallback(() => {
    const email = localStorage.getItem('user_email')
    if (email) {
      return email.split('@')[0];
    }
    return 'no user';
  }, []);

  // const getClient = useCallback(() => {
  //   const arr = JSON.parse(localStorage.getItem('clients')) || []
  //   console.log('arr', arr);
  //   if (Array.isArray(arr) && arr.length > 0 && typeof arr[0].name === 'string') {
  //     return {
  //       name: arr[0].name.slice(0, 7),
  //       id: arr[0].id,
  //     };
  //   }
  //   return 'no client';
  // }, []);

  const getUserId = useCallback(() => {
    const userId = localStorage.getItem('user_id')
    if (userId) {
      return userId;
    }
    return 'no user';
  }, []);

  useEffect(() => {
    // const client = getClient()
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      service_user_email: getUserEmail(),
      // user_client_name: client.name,
      // user_client_id: client.id,
      service_user_id: getUserId(),
    });
  }, [location, getUserEmail, getUserId]);

  return null;
}

export default Analytics;